import { useState } from "react";
import { toast } from "sonner";
import { api, apiError, STATUS_LABEL } from "@/lib/api";

const inp = "mt-1 w-full h-10 rounded-lg border border-gray-200 px-3 text-sm focus:ring-2 focus:ring-emerald-500 focus:outline-none";

export const AbsenceForm = ({ types, operatorId, initial, onSaved, onCancel, testPrefix = "abs" }) => {
  const [f, setF] = useState({
    kind: initial?.kind || types[0]?.key || "ferie",
    start_date: initial?.start_date || "",
    end_date: initial?.end_date || "",
    hours: initial?.hours ?? "",
    reason: initial?.reason || "",
    status: initial?.status || "approved",
  });
  const [busy, setBusy] = useState(false);
  const needsHours = f.kind === "permesso" || f.kind === "recupero";

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const payload = { kind: f.kind, start_date: f.start_date, end_date: f.end_date, reason: f.reason, hours: needsHours && f.hours !== "" ? Number(f.hours) : null };
      if (initial?.id) await api.put(`/absences/${initial.id}`, { ...payload, status: f.status });
      else await api.post("/absences", { ...payload, operator_id: operatorId });
      toast.success(initial?.id ? "Assenza aggiornata" : "Assenza inserita");
      onSaved();
    } catch (err) {
      toast.error(apiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <form onSubmit={submit} data-testid={`${testPrefix}-form`} className="grid grid-cols-2 sm:grid-cols-6 gap-3 items-end rounded-lg border border-dashed border-gray-300 p-3 bg-gray-50">
      <label className="text-xs text-gray-600 col-span-2 sm:col-span-1">Causale
        <select data-testid={`${testPrefix}-kind`} value={f.kind} onChange={(e) => setF({ ...f, kind: e.target.value })} className={inp}>
          {types.map((t) => <option key={t.key} value={t.key}>{t.label}</option>)}
        </select>
      </label>
      <label className="text-xs text-gray-600">Dal
        <input data-testid={`${testPrefix}-start`} required type="date" value={f.start_date} onChange={(e) => setF({ ...f, start_date: e.target.value })} className={inp} />
      </label>
      <label className="text-xs text-gray-600">Al
        <input data-testid={`${testPrefix}-end`} required type="date" value={f.end_date} onChange={(e) => setF({ ...f, end_date: e.target.value })} className={inp} />
      </label>
      {needsHours && (
        <label className="text-xs text-gray-600">Ore
          <input data-testid={`${testPrefix}-hours`} type="number" step="0.5" min="0" value={f.hours} onChange={(e) => setF({ ...f, hours: e.target.value })} className={`${inp} font-mono-num`} />
        </label>
      )}
      {initial?.id && (
        <label className="text-xs text-gray-600">Stato
          <select data-testid={`${testPrefix}-status`} value={f.status} onChange={(e) => setF({ ...f, status: e.target.value })} className={inp}>
            {Object.entries(STATUS_LABEL).map(([k, l]) => <option key={k} value={k}>{l}</option>)}
          </select>
        </label>
      )}
      <label className={`text-xs text-gray-600 col-span-2 ${needsHours || initial?.id ? "sm:col-span-1" : "sm:col-span-2"}`}>Note / motivo
        <input data-testid={`${testPrefix}-reason`} value={f.reason} onChange={(e) => setF({ ...f, reason: e.target.value })} className={inp} placeholder="Opzionale" />
      </label>
      <div className="col-span-2 sm:col-span-6 flex justify-end gap-2">
        {onCancel && <button type="button" data-testid={`${testPrefix}-cancel`} onClick={onCancel} className="h-10 px-3 rounded-lg border border-gray-200 text-sm font-semibold text-gray-600 bg-white">Annulla</button>}
        <button data-testid={`${testPrefix}-save`} disabled={busy} className="h-10 px-4 rounded-lg bg-emerald-600 text-white text-sm font-semibold hover:bg-emerald-700 disabled:opacity-60">
          {busy ? "Salvo..." : initial?.id ? "Salva modifiche" : "Inserisci assenza"}
        </button>
      </div>
    </form>
  );
};
